import templateUrl from './importProficiencyPopup.html';
import controller from './importProficiencyPopup.controller';
import './importProficiencyPopup.scss';

const importProficiencyPopupComponent = {
    bindings: {
        componentReady: '&',
        onSubmit: '&?'
    },
    templateUrl,
    controller
};

export default importProficiencyPopupComponent;
